import { createSlice, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";

const globalInitialState = {
  isLoading: false,
  status: "default",
  message: "",
};

const globalSlice = createSlice({
  name: "global",
  initialState: globalInitialState,
  reducers: {
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setStatus: (state, action) => {
      state.status = action.payload;
    },
    setMessage: (state, action) => {
      state.message = action.payload;
    },
  },
});

const userInitialState = {
  user_data: {},
  accessToken: null,
  currentPin: null,
};

const userSlice = createSlice({
  name: "user",
  initialState: userInitialState,
  reducers: {
    setDataUser: (state, action) => {
      state.user_data = action.payload;
    },
    setAccessToken: (state, action) => {
      state.accessToken = action.payload;
    },
    setCurrentPin: (state, action) => {
      state.currentPin = action.payload;
    },
  },
});

const karyawanInitialState = {
  list_karyawan: [],
  list_karyawan_belum_gaji: [],
  list_tabungan_karyawan: [],
  list_rekap_tabungan_karyawan: [],
  summary_absensi: null,
  list_cabang: [],
};

const karyawanSlice = createSlice({
  name: "karyawan",
  initialState: karyawanInitialState,
  reducers: {
    setListKaryawan: (state, action) => {
      state.list_karyawan = action.payload;
    },
    setListKaryawanNotInputGaji: (state, action) => {
      state.list_karyawan_belum_gaji = action.payload;
    },
    setListTabunganKaryawan: (state, action) => {
      state.list_tabungan_karyawan = action.payload;
    },
    setListRekapTabunganKaryawan: (state, action) => {
      state.list_rekap_tabungan_karyawan = action.payload;
    },
    setSummaryAbsensi: (state, action) => {
      state.summary_absensi = action.payload;
    },
    resetSummaryAbsensi: (state) => {
      state.summary_absensi = null;
    },
    setListCabang: (state, action) => {
      state.list_cabang = action.payload;
    },
  },
});

const divisiInitialState = {
  list_divisi: [],
};

const divisiSlice = createSlice({
  name: "divisi",
  initialState: divisiInitialState,
  reducers: {
    setListDivisi: (state, action) => {
      state.list_divisi = action.payload;
    },
  },
});

const jabatanInitialState = {
  list_jabatan: [],
};

const jabatanSlice = createSlice({
  name: "jabatan",
  initialState: jabatanInitialState,
  reducers: {
    setListJabatan: (state, action) => {
      state.list_jabatan = action.payload;
    },
  },
});

const departemenInitialState = {
  list_departemen: [],
};

const departementSlice = createSlice({
  name: "departement",
  initialState: departemenInitialState,
  reducers: {
    setListDepartemen: (state, action) => {
      state.list_departemen = action.payload;
    },
  },
});

const notifikasiInitialState = {
  list_notifikasi: [],
};

const notifikasiSlice = createSlice({
  name: "notifikasi",
  initialState: notifikasiInitialState,
  reducers: {
    setListNotifikasi: (state, action) => {
      state.list_notifikasi = action.payload;
    },
  },
});

const panduanInitialState = {
  list_panduan: [],
};

const panduanSlice = createSlice({
  name: "panduan",
  initialState: panduanInitialState,
  reducers: {
    setListPanduan: (state, action) => {
      state.list_panduan = action.payload;
    },
  },
});

const aspirasiInitialState = {
  list_aspirasi: [],
};

const aspirasiSlice = createSlice({
  name: "aspirasi",
  initialState: aspirasiInitialState,
  reducers: {
    setListAspirasi: (state, action) => {
      state.list_aspirasi = action.payload;
    },
  },
});

const peringatanInitialState = {
  list_peringatan: [],
};

const peringatanSlice = createSlice({
  name: "peringatan",
  initialState: peringatanInitialState,
  reducers: {
    setListPeringatan: (state, action) => {
      state.list_peringatan = action.payload;
    },
  },
});

const jenjangInitialState = {
  list_jenjang: [],
};

const jenjangSlice = createSlice({
  name: "jenjang",
  initialState: jenjangInitialState,
  reducers: {
    setListJenjang: (state, action) => {
      state.list_jenjang = action.payload;
    },
  },
});

const stockopnameInitialState = {
  list_stockopname: [],
  list_peserta_so: [],
  list_karyawan_so: [],
};

const stockopnameSlice = createSlice({
  name: "stockopname",
  initialState: stockopnameInitialState,
  reducers: {
    setListStockopname: (state, action) => {
      state.list_stockopname = action.payload;
    },
    setListPeserta: (state, action) => {
      state.list_peserta_so = action.payload;
    },
    setListKaryawanSO: (state, action) => {
      state.list_karyawan_so = action.payload;
    },
  },
});

const absensiInitialState = {
  list_absensi_hariini: [],
  list_absensi_bulanan: [],
  list_absensi_harian: [],
};

const absensiSlice = createSlice({
  name: "absensi",
  initialState: absensiInitialState,
  reducers: {
    setListAbsensiHariIni: (state, action) => {
      state.list_absensi_hariini = action.payload;
    },
    setListAbsensiBulanan: (state, action) => {
      state.list_absensi_bulanan = action.payload;
    },
    setListAbsensiHarian: (state, action) => {
      state.list_absensi_harian = action.payload;
    },
  },
});

const setoranInitialState = {
  list_setoran: [],
  list_pencapaian: [],
  detail_setoran_harian: null,
  pengeluaran_setoran: null,
  pengeluaran_setoran_global: null,
};

const setoranSlice = createSlice({
  name: "setoran",
  initialState: setoranInitialState,
  reducers: {
    setListSetoran: (state, action) => {
      state.list_setoran = action.payload;
    },
    setListPencapaian: (state, action) => {
      state.list_pencapaian = action.payload;
    },
    setDetailSetoranHarian: (state, action) => {
      state.detail_setoran_harian = action.payload;
    },
    resetDetailSetoranHarian: (state, action) => {
      state.detail_setoran_harian = null;
    },
    setPengeluaranSetoran: (state, action) => {
      state.pengeluaran_setoran = action.payload;
    },
    setPengeluaranSetoranGlobal: (state, action) => {
      state.pengeluaran_setoran_global = action.payload;
    },
    resetPengeluaranSetoran: (state, action) => {
      state.pengeluaran_setoran = null;
    },
  },
});

const gajiInitialState = {
  list_gaji: [],
};

const gajiSlice = createSlice({
  name: "gaji",
  initialState: gajiInitialState,
  reducers: {
    setListGaji: (state, action) => {
      state.list_gaji = action.payload;
    },
  },
});

const cabangInitialState = {
  list_cabang: [],
};

const cabangSlice = createSlice({
  name: "cabang",
  initialState: cabangInitialState,
  reducers: {
    changeListCabang: (state, action) => {
      state.list_cabang = action.payload;
    },
  },
});

const alokasiInitialState = {
  list_transaksi_warkat: [],
  list_transaksi: [],
  list_perkiraan: [],
};

const alokasiSlice = createSlice({
  name: "alokasi",
  initialState: alokasiInitialState,
  reducers: {
    setListTransaksiWarkat: (state, action) => {
      state.list_transaksi_warkat = action.payload;
    },
    setListTransaksi: (state, action) => {
      state.list_transaksi = action.payload;
    },
    setListPerkiraan: (state, action) => {
      state.list_perkiraan = action.payload;
    },
  },
});

const persistConfig = {
  key: "user",
  storage,
};

const rootReducer = combineReducers({
  global: globalSlice.reducer,
  user: persistReducer(persistConfig, userSlice.reducer),
  karyawan: karyawanSlice.reducer,
  notifikasi: notifikasiSlice.reducer,
  so: stockopnameSlice.reducer,
  absensi: absensiSlice.reducer,
  divisi: divisiSlice.reducer,
  jabatan: jabatanSlice.reducer,
  departemen: departementSlice.reducer,
  panduan: panduanSlice.reducer,
  aspirasi: aspirasiSlice.reducer,
  peringatan: peringatanSlice.reducer,
  setoran: setoranSlice.reducer,
  gaji: gajiSlice.reducer,
  cabang: cabangSlice.reducer,
  jenjang: jenjangSlice.reducer,
  alokasi: alokasiSlice.reducer,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

const persistor = persistStore(store);

export { store, persistor };
export const { setIsLoading, setStatus, setMessage } = globalSlice.actions;
export const { setDataUser, setAccessToken, setCurrentPin } = userSlice.actions;
export const {
  setListKaryawan,
  setListKaryawanNotInputGaji,
  setListTabunganKaryawan,
  setListRekapTabunganKaryawan,
  setSummaryAbsensi,
  resetSummaryAbsensi,
  setListCabang,
} = karyawanSlice.actions;
export const { setListDepartemen } = departementSlice.actions;
export const { changeListCabang } = cabangSlice.actions;
export const { setListDivisi } = divisiSlice.actions;
export const { setListJabatan } = jabatanSlice.actions;
export const { setListNotifikasi } = notifikasiSlice.actions;
export const { setListPanduan } = panduanSlice.actions;
export const { setListAspirasi } = aspirasiSlice.actions;
export const { setListPeringatan } = peringatanSlice.actions;
export const { setListJenjang } = jenjangSlice.actions;
export const { setListStockopname, setListPeserta, setListKaryawanSO } =
  stockopnameSlice.actions;
export const {
  setListAbsensiHariIni,
  setListAbsensiBulanan,
  setListAbsensiHarian,
} = absensiSlice.actions;
export const {
  setListSetoran,
  setListPencapaian,
  setDetailSetoranHarian,
  resetDetailSetoranHarian,
  setPengeluaranSetoran,
  setPengeluaranSetoranGlobal,
  resetPengeluaranSetoran,
} = setoranSlice.actions;
export const { setListGaji } = gajiSlice.actions;
export const { setListTransaksi, setListPerkiraan, setListTransaksiWarkat } =
  alokasiSlice.actions;
